import { render, staticRenderFns } from "./BlocLinks.vue?vue&type=template&id=31e57547&lang=pug&"
import script from "./BlocLinks.vue?vue&type=script&lang=js&"
export * from "./BlocLinks.vue?vue&type=script&lang=js&"
import style0 from "./BlocLinks.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e57547')) {
      api.createRecord('31e57547', component.options)
    } else {
      api.reload('31e57547', component.options)
    }
    module.hot.accept("./BlocLinks.vue?vue&type=template&id=31e57547&lang=pug&", function () {
      api.rerender('31e57547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/BlocLinks.vue"
export default component.exports